import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import type { Scope } from '../components/ScopeToggle';

const STORAGE_KEY = 'berg-scope';

function readStored(): Scope {
  if (typeof window === 'undefined') return 'household';
  const raw = window.localStorage.getItem(STORAGE_KEY);
  return raw === 'dakota' || raw === 'natalia' ? raw : 'household';
}

type ScopeContextValue = {
  scope: Scope;
  setScope: (next: Scope) => void;
};

const ScopeContext = createContext<ScopeContextValue | null>(null);

export function ScopeProvider({ children }: { children: ReactNode }) {
  const [scope, setScope] = useState<Scope>(readStored);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, scope);
    } catch {
      // localStorage may be unavailable (private mode, quota); the in-memory
      // value is still authoritative for this session, so swallow.
    }
  }, [scope]);

  return (
    <ScopeContext.Provider value={{ scope, setScope }}>
      {children}
    </ScopeContext.Provider>
  );
}

export function useScope(): ScopeContextValue {
  const ctx = useContext(ScopeContext);
  if (!ctx) throw new Error('useScope must be used inside <ScopeProvider>');
  return ctx;
}
